var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subcategory"},[(_vm.subcategories && _vm.subcategories.length)?_c('SfCarousel',{staticClass:"subcategory-carousel",attrs:{"data-cy":"subcategory-carousel","settings":{
      type: 'carousel',
      rewind: false,
      perView: 6,
      gap: 18,
      slidePerPage: false,
      breakpoints: { 1023: { perView: 2.2, peek: 0 } },
    }}},_vm._l((_vm.subcategories),function(category,i){return _c('SfCarouselItem',{key:i,staticClass:"category__item"},[_c('SfLink',{attrs:{"link":_vm.localePath(_vm.getCatLink(category))}},[_c('span',{staticClass:"h6"},[_vm._v(_vm._s(category.name))])])],1)}),1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }